import { render, staticRenderFns } from "./AlertResourceError.vue?vue&type=template&id=45945d1e&"
import script from "./AlertResourceError.vue?vue&type=script&lang=js&"
export * from "./AlertResourceError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports